import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ressult() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>The Results</h2>
            <p>
              TekRevol believes in empowering our clients, partners, and all
              stakeholders through unparalleled support. With Al Hussaini
              Trading Company, based on a collaborative approach, we concluded
              with an ideal plan that was concentrated on digital transformation
              and customer experience – rebuilding the eCommerce site from
              scratch and strategizing it in the right direction.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <StaticImage
              src="../../../images/case-studies/alhussaini/tek-img_07.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={902}
              height={535}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ressult;
